/**
 * Cited sources disclosure — opening it hides the "View all sources" summary
 * the user just activated, so move focus to the revealed list instead of
 * dropping it on <body>.
 *
 * `toggle` doesn't bubble, so listen in the capture phase.
 */
document.addEventListener(
	'toggle',
	(event) => {
		const details = event.target

		if (!(details instanceof HTMLDetailsElement) || !details.matches('[data-sources-more]') || !details.open) {
			return
		}

		details.querySelector('[data-sources-more-list]')?.focus()
	},
	true
)
